import { useContext } from 'react';

import MenuManagementMenuPreviewContext from 'context/MenuManagementMenuPreviewContext';

export const useMenuPreview = () => useContext(MenuManagementMenuPreviewContext);
